<script lang="ts">
    import cn from 'classnames';

    import type { Action } from '@uikit/actions';

    import { Link } from '@uikit/link';
    import { imageLoad } from '@uikit/actions/image-load';
    import { Target } from '@uikit/types';

    import { Size } from '../../types';
    import { getColorByUserId, getFirstUpperLetter } from '../../functions';

    import type { Attrs } from './types';

    import s from './thumb.module.css';

    export let userName: string;
    export let userId: number;
    export let thumbUrl: NullableString = undefined;
    export let size: Size = Size.medium;
    export let href: NullableString = undefined;
    export let attrs: Partial<Attrs> = {};
    export let imgLazyLoad: boolean = false;
    export let target: Target = Target.self;
    export let action: Action | undefined = undefined;

    function thumbHandler(image: HTMLImageElement, success: boolean) {
        if (!success) {
            thumbUrl = null;
        }
    }
</script>

<Link {href} {target} classes={s.link} {action}>
    {#if thumbUrl}
        <img
            class={s.image}
            src={thumbUrl}
            alt={userName}
            use:imageLoad={thumbHandler}
            fetchpriority="low"
            loading={imgLazyLoad ? 'lazy' : null}
            {...attrs}
        />
    {:else}
        <div class={cn(s.char, s[size])} style="background-color: {getColorByUserId(userId)}">
            <div>{getFirstUpperLetter(userName)}</div>
        </div>
    {/if}
</Link>
